import buildMutedPreview from "./functions/build-muted-preview";

let config, $selector;

export default async function ({ config: cf, $selector: $sel }) {
  config = cf;
  $selector = $sel;

  return new Promise((resolve, reject) => {
    // maybe build muted preview
    if (config?.blockAttributes?.mutedPreview?.enabled) {
      var ua = window.navigator.userAgent;
      var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      if (iOS) {
        console.log("ios device, do not do muted autoplay");
        resolve(true);
        return;
      }

      buildMutedPreview($selector.get(0), config);
      resolve(false);
      return;
    }

    resolve(true);
  });
}
